// import { ResultOf } from "gql.tada";
// import { AccessibleMediaFragment } from "@queries/fragments/AccessibleMediaFragment";

export const AccessibleMedia = ({
  item,
}: {
  // item: ResultOf<typeof AccessibleMediaFragment>;
  item: any;
}) => {
  if (!item) return null;

  const mediaType = item?.media?.contentType?.split('/')[0];
  const classNames = "w-full select-none drag-none block object-contain mx-auto";

  const getMedia = () => {
    switch (mediaType) {
      case 'image':
        return (
          <img
            src={item?.media?.url as string}
            alt={item?.altText as string}
            className={classNames}
          />
        )

    case 'video':
      return (
        <video
          controls
          poster={item?.posterImage?.url as string}
          src={item?.media?.url as string}
          className={classNames}
        />
      )

    case 'audio':
      return (
        <audio
          controls
          src={item?.media?.url as string}
          className={classNames}
        />
      )

    default:
      return <></>;
    }
  }

  return (
    <>
      {getMedia()}
    </>
  );
};
